/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { UUID } from '@builddocs/data-management'
import { useQuery } from 'react-query'
import { useRecoilValueLoadable, useSetRecoilState } from 'recoil'

import { getSheetsWorkingDraft } from '../applications'

import { sheetsQuery, sheetsQueryRequestIDState } from './sheets.container'

// Оригинальный хук через Recoil
export const useSheets = (id: UUID) => {
  const listsWorkingDraftLoadable = useRecoilValueLoadable(sheetsQuery(id))

  const setRequestID = useSetRecoilState(sheetsQueryRequestIDState(id))
  const refreshSheets = () => setRequestID(requestID => requestID + 1)

  const sheets =
    listsWorkingDraftLoadable.state === 'hasValue'
      ? listsWorkingDraftLoadable.contents
      : []

  return { sheets, refreshSheets }
}

// Аналогичный хук на useQuery

export const useSheetsQuery = (id: UUID) => {
  return useQuery({
    queryKey: ['sheets', id],
    queryFn: () => getSheetsWorkingDraft(id),
  })
}
